import BestCity from './packages/BestCity.vue';

BestCity.install = Vue => Vue.component(BestCity.name, BestCity);

// 导出模块
export default BestCity;



// WEBPACK FOOTER //
// ./src/index.js